import { makeObservable } from 'mobx'
import { Slide } from './Slide'
import { sortQuestions } from '../../../sources-of-truth/sortQuestions'

export class GroupQuizSlide extends Slide {
  isGroup = true

  afterConstructor() {
    makeObservable(this, {
      questions: true,
    })
  }

  get questions() {
    const quizQuestionsForSlide = this.meeting.questions.filter(
      (q) => q.groupSlideId === this.meeting.currentSlide?.id && q.isQuiz
    )
    return sortQuestions({
      questions: quizQuestionsForSlide,
      slideIds: [],
      isGroupQuiz: true,
    })
  }
}
